import { render, staticRenderFns } from "./CustomerToolbar.vue?vue&type=template&id=5038f484&"
import script from "./CustomerToolbar.vue?vue&type=script&lang=js&"
export * from "./CustomerToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerToolbar.vue"
export default component.exports